import React from 'react';
import CreateCoupon from 'containers/Coupons/CreateCoupon';

const CreateCouponPage = () => <CreateCoupon />;

export default CreateCouponPage;
